export const colors = {
  white: '#ffffff',
  primary: '#364347',
  secondary: '#02baf2',
  border: '#b2c6cd',
  concrete: '#f3f3f3',
  info: '#e9f5fe',
  text: '#0d3c61',
};
